import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=3fb8663a&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"
import style0 from "./recruit.vue?vue&type=style&index=0&id=3fb8663a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8663a",
  null
  
)

export default component.exports